import { useEffect, useState, useRef } from 'react';
import _ from 'lodash';
import {
    Link,
    useParams,
    useNavigate,
} from "react-router-dom";
import MInput from '../../Components/Input';
import MTable from '../../Components/MTable/MTable';
import ResultContainerPlugin from '../../Components/ResultContainerPlugin';
import { Html5QrcodeScanner } from "html5-qrcode";
import { getSODelivery } from '../../Service/SalesService';
import { empty_data, print } from '../../Images';
import { cancelDelivery, createDelivery, getDelivery, getSODetail, updatePrintCount } from '../../Service/DeliveryService';
import moment from 'moment';
import Swal from 'sweetalert2';
import { handlerFormError } from '../../Utils/Utils';
import Overlay from '../../Components/Overlay/Overlay';
import { useReactToPrint } from 'react-to-print';
import PrintDelivery from './PrintDelivery';
import { useSelector } from 'react-redux';

const DeliveryForm = () => {
    const { $ } = window;
    let { userInfo } = useSelector(state => state.auth);
    const mTableC = useRef();
    const navigate = useNavigate();
    const componentRef = useRef();
    const { pageState, id_delivery } = useParams();
    const [serials, setSerial] = useState([]);
    const [errors, setErrors] = useState({
        driver: '',
        vehicle: ''
    })
    const [state, setState] = useState({
        order_no: '',
        nama_customer: '',
        driver: '',
        vehicle: '',
        order_type: 'Delivery Note',
        delivery_number: '',
        delivery_date: moment().format('YYYY-MM-DD'),
        detail: [],
        processing: false,
        locked: true,
        status: 'Open',
        shipping_address: '',
        shipping_country: '',
        shipping_city: '',
        shipping_phone: '',
        docnumso : '',
        print_count: ""
    });
    useEffect(_ => {
        initPage();
    }, [])

    const initPage = () => {
        
        switch (pageState) {
            case 'create':
                
            break;
            case 'edit':
                const request = [
                    getDelivery(id_delivery).then(res => res.data)
                ];
                Promise.all(request).then(results => {
                    const [_delivery] = results;
                    let arr_detail = [];
                    let isLocked = true;
                    for (const key in _delivery.product_details){
                        arr_detail.push({
                            line_num: _delivery.product_details[key].line_num,
                            itemname : _delivery.product_details[key].item_name,
                            itemno : _delivery.product_details[key].item_code,
                            order_qty : _delivery.product_details[key].order_qty,
                            open_qty_default : _delivery.product_details[key].open_qty,
                            open_qty: _delivery.product_details[key].current_qty,
                            show: _delivery.product_details[key].open_qty == 0 ? false :  true
                        });
                        if(_delivery.product_details[key].open_qty > 0){
                            isLocked = false;
                        }
                    }

                    if(_delivery.status == 'Cancel') {
                        isLocked = true;
                    }
                    setState({ ...state, 
                        order_no: _delivery.order,
                        order_id: id_delivery,
                        nama_customer: _delivery.customer,
                        status: _delivery.status,
                        delivery_number: _delivery.delivery_number,
                        driver: _delivery.driver,
                        vehicle: _delivery.vehicle,
                        order_type: _delivery.delivery_type,
                        delivery_date: _delivery.delivery_date,
                        detail: arr_detail,
                        loading: false,
                        locked: isLocked,
                        shipping_address: _delivery.shipping_address,
                        shipping_country: _delivery.shipping_country,
                        shipping_city: _delivery.shipping_city,
                        shipping_phone: _delivery.shipping_phone,
                        docnumso : _delivery.docnumso,
                        print_count: _delivery.print_count
                    });
                })
            break;
        }
    }

    const onShowModal = () => {
        $("#modal-detail").modal();
        mTableC.current.refresh();
    }
    const onShowModalScan = () => {
        $("#modal-scan").modal();
        createScan();
    }

    const onChangeDriver = (e) => {
        setState({...state, driver: e.target.value});
    }
    const onChangeVehicle = (e) => {
        setState({...state, vehicle: e.target.value});
    }

    const onChangeQty = (e, row) => {
        let _detail = state.detail;
        const index = _detail.findIndex(e => e.line_num == row.line_num);
        if(index > -1) {
            _detail[index].open_qty = e.target.value == "" ? 0 : e.target.value;
            if(e.target.value < 0){
                _detail[index].open_qty = 1;
            }
        }
        setState({...state, detail: _detail});
    }

    const onNewScanResult = (decodedText, decodedResult) => {
        setSerial(state => [...state, decodedResult]);
    }
    const createScan = () => {
        const config = { fps: 10, qrbox: { width: 250, height: 250 } };
        const html5QrcodeScanner = new Html5QrcodeScanner(
            "reader",
            config
        );
        html5QrcodeScanner.render(onNewScanResult);
    }

    const onSelectOrder = item => () => {
        getSODetail(item.id_so)
        .then(res => {
            let _delivery = res.data;
            let arr_detail = [];
            let isLocked = true;
            for (const key in _delivery.product_details){
                arr_detail.push({
                    line_num: _delivery.product_details[key].line_num,
                    itemname : _delivery.product_details[key].item_name,
                    itemno : _delivery.product_details[key].item_code,
                    order_qty : _delivery.product_details[key].order_qty,
                    open_qty: _delivery.product_details[key].open_qty,
                    open_qty_default: _delivery.product_details[key].open_qty,
                    show: _delivery.product_details[key].open_qty == 0 ? false :  true
                });
                if(_delivery.product_details[key].open_qty > 0){
                    isLocked = false;
                }
            }
            setState({ ...state, 
                order_no: _delivery.order,
                order_id: item.id_so,
                nama_customer: _delivery.customer,
                delivery_number: _delivery.delivery_number,
                status: "Open",
                driver: _delivery.driver == "-"? "": _delivery.driver,
                vehicle: _delivery.vehicle == "-"? "": _delivery.vehicle,
                //order_type: _delivery.delivery_type,
                delivery_date: _delivery.delivery_date,
                detail: arr_detail,
                loading: false,
                locked: isLocked,
                docnumso : _delivery.docnumso
            });

            $("#modal-detail").modal('hide');
            
        }).catch(({ response: { data } }) => {
            handlerFormError(data);
        });
    
    };

    const columns = [
        {
            id: 1,
            title: 'Order No',
            field: 'DocNumSO',
            sortable: true,
            render: item => {
                return (
                    <a
                        onClick={onSelectOrder(item)}
                        style={{
                            cursor: 'pointer',
                            fontWeight: '500'
                        }}
                    >
                        {item.DocNumSO}
                    </a>
                )
            }
        },
        // { id: 2, title: 'DocNumSO', field: 'DocNumSO', sortable: true },
        { id: 2, title: 'Customer', field: 'CardName', sortable: true },
        { id: 3, title: 'Created Date', field: 'created_date', sortable: true },
    ];

    const printPrompt = () => {

        if(state.print_count === 0) {
            const swalWithBootstrapButtons = Swal.mixin({
                customClass: {
                  confirmButton: 'btn btn-modena',
                  cancelButton: 'btn btn-readonly mr-3'
                },
                buttonsStyling: false
            })
            swalWithBootstrapButtons.fire(
                {
                    title: 'Are you sure?',
                    text: "By selecting 'Sure', you can't void the receipt anymore, and the next print will be watermarked even if you choose to cancel the print.",
                    confirmButtonColor: '#3085d6',
                    showCancelButton: true,
                    confirmButtonText: 'Sure',
                    reverseButtons: true
                }
            ).then(({ isConfirmed }) => {
                if(isConfirmed){
                    updatePrintCount(id_delivery).then(res => {
                        if(res.data.status == 200){
                            setState({...state, print_count: state.print_count + 1})
                            handlePrint()
                        }
                    }
                );
                }
            })
        } else {
            updatePrintCount(id_delivery).then(res => {
                if(res.data.status == 200){
                    setState({...state, print_count: state.print_count + 1})
                    handlePrint()
                }
            });
        }

    }

   useEffect(() => console.log(state), [state]);

   const cancelButtonDisabler = (form_state) => {
    if(form_state.order_type === "Receipt Note" && form_state.print_count > 0) {
        return true;
    }

    return false;
   }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        copyStyles: true,
    });

    const submitDelivery = () => {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              confirmButton: 'btn btn-modena',
              cancelButton: 'btn btn-readonly mr-3'
            },
            buttonsStyling: false
        })
        swalWithBootstrapButtons.fire(
            {
                title: 'Confirmation',
                text: 'Are you sure Delivery this Items ?',
                confirmButtonColor: '#3085d6',
                showCancelButton: true,
                confirmButtonText: 'Sure',
                reverseButtons: true
            }
        ).then(({ isConfirmed }) => {
            if (isConfirmed) {

                let arr_item = []
                for (const key in state.detail) {
                    if(state.detail[key].open_qty > 0){
                        arr_item.push({
                            line_num : state.detail[key].line_num,
                            item_code : state.detail[key].itemno,
                            qty_delivery : state.detail[key].open_qty
                        });
                    }
                }
                const payload = {
                    so_id: state.order_id,
                    driver: state.driver,
                    vehicle: state.vehicle,
                    created_date: moment().format('YYYY-MM-DD HH:mm:ss'),
                    delivery_date: state.delivery_date,
                    item_codes: arr_item,
                    order_type: state.order_type
                };

                if(payload.order_type == "Receipt Note"){
                    payload.driver  = "-";
                    payload.vehicle = "-";
                }
        
                setState({ ...state, processing: true });
                createDelivery(payload, res => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Create Delivery success '
                    }).then(res => {
                        setState({...state, refresh: true});
                        navigate('/delivery');
                    });
                }, ({ response }) => {
                    processSubmitError(response.data);
                    Swal.fire({
                        icon: 'error',
                        title: 'Create Delivery Error',
                        text: response.data.message
                    });
                }).finally(() => {
                    setState({ ...state, processing: false });
                });
            }
        })
    }

    const onDateDeliveryChange = (event) => {
        let tgl = moment(event.target.value).format('YYYY-MM-DD');
        let today = moment()
        if(today.diff(tgl, 'days') > 0){
            Swal.fire({
                icon: 'error',
                timer: 1500,
                showConfirmButton: false,
                title: "Delivery date cannot be lower than today..!"
            });
            return;
        }
        setState({ ...state, delivery_date: event.target.value });
    }

    const processSubmitError = (response) => {
        if(response.errors && !_.isEmpty(response.errors)){
            const {driver, vehicle} = response.errors;
            setErrors({...errors, driver: driver[0], vehicle: vehicle[0]});
        }
    }

    const cancDelivery = () => {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              confirmButton: 'btn btn-danger',
              cancelButton: 'btn btn-readonly mr-3'
            },
            buttonsStyling: false
        })
        swalWithBootstrapButtons.fire(
            {
                title: 'Confirmation',
                text: 'Are you sure Delivery this Items ?',
                confirmButtonColor: '#3085d6',
                showCancelButton: true,
                confirmButtonText: 'Sure',
                reverseButtons: true
            }
        ).then(({ isConfirmed }) => {
            if (isConfirmed) {

                const payload = {
                    status : "Cancel"
                };
        
                setState({ ...state, processing: true });
                cancelDelivery(state.order_id,payload, res => {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Cancel Delivery success '
                    }).then(res => {
                        setState({...state, refresh: true});
                        navigate('/delivery');
                    });
                }, ({ response }) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Cancel Delivery Error',
                        text: response.data.message
                    });
                }).finally(() => {
                    setState({ ...state, processing: false });
                });
            }
        })
    }

    const propsTable = { columns, getData: getSODelivery, showIndex: true, order: 'DocNumSO', direction: 'desc', showPaginationCounter:false };
    const propsPrint = { getState: state, login: userInfo }

    return (
        <div className="content-wrapper">
            <Overlay display={state.processing} />
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-12">
                            <h2 className="title-breadcrum">
                            {pageState == 'create' ? 'Create Delivery' : 'Delivery #' + state.delivery_number}&nbsp;
                            { state.status == 'Close' ?
                                <span className="badge bg-close me-2">Closed</span>
                            : state.status == 'Open' ?
                                <span className="badge bg-cyan me-2">Open </span> 
                            : state.status == 'Cancel' ?
                                <span className="badge bg-red me-2">Cancel</span> : ''
                            }

                            { state.status == "Close" && 
                            <>
                                <div style={{display: 'none'}}>
                                    <PrintDelivery  ref={componentRef} {...propsPrint}/>
                                </div>
                                <div style={{float: 'right', cursor: 'pointer'}}>
                                    <img src={print} onClick={state.order_type == "Receipt Note" ? printPrompt: handlePrint} />
                                </div>
                            </>
                            }   
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 bg-white">
                            <h6 className="m-0 title-breadcrum tx-gray" >
                                Info Delivery 
                            </h6>
                        </div>
                        <div className="card-body">
                            <div className='row' style={{ padding: '10px 65px' }}>
                                <div className='col-sm-4'>
                                    <div className="mb-3">
                                        {state.status !== "Close" && state.status !== "Cancel" ?
                                        <MInput
                                            name='docnumso'
                                            label='Order'
                                            type='text'
                                            role='button'
                                            readOnly
                                            value={state.docnumso}
                                            onClick={onShowModal}
                                            required
                                        />
                                        :
                                        <MInput
                                            name='docnumso'
                                            label='Order'
                                            type='text'
                                            readOnly
                                            value={state.docnumso}
                                            required
                                        />
                                        }
                                    </div>

                                </div>
                                <div className='col-sm-4'>
                                    <div className="mb-3">
                                        <MInput
                                            name='nama_customer'
                                            label='Customer'
                                            type='text'
                                            readOnly
                                            value={state.nama_customer}
                                            required
                                        />
                                    </div>

                                </div>
                                <div className='col-sm-4'>
                                    <div className="mb-3">
                                        <MInput
                                            id='delivery_date'
                                            name='delivery_date'
                                            label='Delivery Date'
                                            type='date'
                                            value={moment(state.delivery_date).format('YYYY-MM-DD')}
                                            onChange={onDateDeliveryChange}
                                            icon={<i className="bi bi-calendar3"></i>}
                                            readOnly={state.locked}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='row' style={{ padding: '10px 65px' }}>
                                <div className='col-sm-4'>
                                    <div className="mb-3">
                                        <MInput
                                            name='driver'
                                            label='Driver'
                                            type='text'
                                            readOnly={state.locked}
                                            value={state.driver}
                                            onChange={onChangeDriver}
                                            required={state.order_type == "Delivery Note"}
                                            disabled={state.order_type !== "Delivery Note"}

                                        />
                                        {errors.driver && <span style={{color:"red"}}>{errors.driver}</span>}
                                    </div>

                                </div>
                                <div className='col-sm-4'>
                                    <div className="mb-3">
                                        <MInput
                                            name='vehicle'
                                            label='Vehicle'
                                            type='text'
                                            readOnly={state.locked}
                                            value={state.vehicle}
                                            onChange={onChangeVehicle}
                                            required={state.order_type == "Delivery Note"}
                                            disabled={state.order_type !== "Delivery Note"}
                                        />
                                         {errors.vehicle && <span style={{color:"red"}}>{errors.vehicle}</span>}
                                    </div>

                                </div>
                                <div className='col-sm-4'>
                                    <div className="mb-3">
                                        <label>Delivery Type</label>
                                        <div className="input-group input-group-joined mb-4">
                                            <select name='order_type' value={state.order_type} 
                                                onChange={e => {
                                                    let driver = state.driver;
                                                    let vehicle = state.vehicle;
                                                    if(e.target.value == "Receipt Note") {
                                                        driver = "-";
                                                        vehicle = "-";
                                                    }
                                                    setState({...state, order_type: e.target.value, driver, vehicle})
                                                }} 
                                                className='form-control'
                                                disabled={state.locked} >
                                                <option value='Delivery Note'>Delivery Note</option>
                                                <option value='Receipt Note'>Receipt Note</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div id="modal-detail" className='modal'>
                        <div className='modal-dialog modal-dialog-centered modal-lg'>
                            <div className='modal-content'>
                                <div className='modal-header'>
                                    <h5 className="modal-title"> List Sales Order</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className='modal-body'>
                                    <MTable ref={mTableC} {...propsTable} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="modal-scan" className='modal'>
                        <div className='modal-dialog modal-dialog-centered modal-lg'>
                            <div className='modal-content'>
                                <div className='modal-header'>
                                    <h5 className="modal-title"><b>SCAN MODENA GAS HOB - BH 0725</b><br />
                                        (SKU2199903)
                                    </h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className='modal-body'>
                                    <p>Use your camera to capture QR</p>
                                    <div className='panel-camera' id="reader"></div>
                                    <ResultContainerPlugin results={serials} />

                                    <button className="btn btn-modena" style={{ marginBottom: 30, marginTop: 30, float: 'right' }} type="button">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {state.detail && state.detail.length > 0 ?
                        <>
                            <div className="card shadow mb-4">
                                <div className="card-header py-3 bg-white">
                                    <div className='row'>
                                        <div className='col-sm-8'>
                                            <h6 className="m-0 title-breadcrum tx-gray" >Detail Product</h6>
                                        </div>

                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-hover" id="dataTable" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th className='th-no-border'>No</th>
                                                    <th className='th-no-border'>Product</th>
                                                    <th className='th-no-border'>Sales Qty</th>
                                                    <th className='th-no-border'>Open Quantity</th>
                                                    <th className='th-no-border'>Quantity</th>
                                                    {/* <th className='th-no-border'></th> */}
                                                </tr>
                                            </thead>

                                            <tbody>
                                            {state.detail.map((row, index) => (
                                                <tr key={`tr-` + index} >
                                                    
                                                    <td>{index+1}</td>
                                                    <td>
                                                        <label style={{ display: 'block' }}>{row.itemname} ({row.itemno})</label>
                                                    </td>
                                                    <td width={180}>
                                                        <input className="form-control ps-0" type="number" value={row.order_qty} readOnly={true}/>
                                                    </td>
                                                    <td width={180}>
                                                        <input className="form-control ps-0" type="number" value={row.open_qty_default} readOnly={true}/>
                                                    </td>
                                                    <td width={180}>
                                                        <input className="form-control ps-0" name={`qty-` + index} type="number" value={row.open_qty} max={row.open_qty_default} min={0} onChange={(e) => onChangeQty(e, row)} readOnly={!row.show || state.status == "Close"} />
                                                    </td>
                                                    {/* <td>
                                                        <div>
                                                            <button className="btn btn-outline-warning"
                                                                disabled={!row.show}
                                                                onClick={onShowModalScan}
                                                                style={{ border: 'dotted', marginBottom: 10, width: 100 }} type="button">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-qr-code-scan" viewBox="0 0 16 16">
                                                                    <path d="M0 .5A.5.5 0 0 1 .5 0h3a.5.5 0 0 1 0 1H1v2.5a.5.5 0 0 1-1 0v-3Zm12 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V1h-2.5a.5.5 0 0 1-.5-.5ZM.5 12a.5.5 0 0 1 .5.5V15h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5Zm15 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H15v-2.5a.5.5 0 0 1 .5-.5ZM4 4h1v1H4V4Z" />
                                                                    <path d="M7 2H2v5h5V2ZM3 3h3v3H3V3Zm2 8H4v1h1v-1Z" />
                                                                    <path d="M7 9H2v5h5V9Zm-4 1h3v3H3v-3Zm8-6h1v1h-1V4Z" />
                                                                    <path d="M9 2h5v5H9V2Zm1 1v3h3V3h-3ZM8 8v2h1v1H8v1h2v-2h1v2h1v-1h2v-1h-3V8H8Zm2 2H9V9h1v1Zm4 2h-1v1h-2v1h3v-2Zm-4 2v-1H8v1h2Z" />
                                                                    <path d="M12 9h2V8h-2v1Z" />
                                                                </svg>&nbsp;Scan
                                                            </button>
                                                        </div>

                                                    </td> */}
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>

                                    </div>


                                </div>
                            </div>
                            <div className='row' style={{ justifyContent: 'flex-end' }}>
                                <div className='col-sm-2'>
                                    <Link to="/delivery" className='btn btn-readonly btn-block' style={{ marginBottom: 30 }}>Back</Link>
                                </div>
                                { state.status !== "Close" && state.status !== "Cancel" &&
                                <div className='col-sm-3'>
                                    <button className="btn btn-modena btn-block" style={{ marginBottom: 30 }} type="button" onClick={submitDelivery}>
                                        Create Delivery
                                    </button>
                                </div>
                                }
                                { state.status == "Close" &&
                                <div className='col-sm-2'>
                                    <button className="btn btn-danger btn-block" style={{ marginBottom: 30 }} type="button" onClick={cancDelivery} disabled={cancelButtonDisabler(state)}>
                                        {state.order_type == "Receipt Note"? "Void": "Cancel"}
                                    </button>
                                </div>
                                }
                            </div>
                        </>
                        :
                        <div className='row d-block'>
                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className='row d-flex align-items-center justify-content-center'>
                                        <img src={empty_data} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </section>
        </div>
    );

};

export default DeliveryForm;